import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import jsCookie from "js-cookie";

const indexRouter = {
  path: "/:activityId",
  component: Home,
  children: []
};

let routes = [indexRouter];

const routerContext = require.context("./modules", true, /\.js$/);
routerContext.keys().forEach((route) => {
  const routerModule = routerContext(route);
  routes = [...routes, ...(routerModule.default || routerModule)];
});

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    // 校验中山+存储的授权信息
    const zsplusInfo = sessionStorage.getItem("zsplusInfo");
    const token = jsCookie.get("token");
    if (!token && to.name !== "zsplus_auth") {
      sessionStorage.setItem("zsplusRedirectUrl", to.fullPath);
      next({
        name: "zsplus_auth"
      });
    } else if (!zsplusInfo && to.name !== "zsplus_auth") {
      sessionStorage.setItem("zsplusRedirectUrl", to.fullPath);
      next({
        name: "zsplus_auth"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

// vue项目，参数根据实际情况填写：
router.afterEach(() => {
  window.TrackKit.zmyAdapter.openActivityH5({
    activity_id: "drawform", // 活动id
    url: window.location.href
  });
  window.TrackKit.umengAdapter.trackPageView();
  window.TrackKit.umengAdapter.setExposure();
});

export default router;
